<template>
    <div id="page-app">
        <div class="p-3 d-filter-app">
            <v-text-field class="w-100" v-model="keySearchApp" solo dense :label="$t('ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR')" append-icon="search"></v-text-field>
        </div>
        <div class="d-app-content h-100">
          <v-expansion-panels accordion multiple v-model="panel">
            <v-expansion-panel
              v-for="(item,i) in arrAppView"
              :key="i"
            >
              <v-expansion-panel-header>{{$i18n.locale === 'en' ? item.nameEn : item.name}}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <b-row>
                  <b-col cols="4" v-for="(app, index) in item.appLinks" class="text-center d-app-item py-0" @click="openApp(app)">
                    <div class="d-img-app">
                      <img :src="app.icon">
                    </div>
                    <div class="fs-12">
                      {{app.name}}
                      <p class="fs-10 text-secondary">{{$i18n.locale === 'en' ? app.descriptionEn : app.description}}</p>
                    </div>
                  </b-col>
                </b-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
         <div class="d-flex align-items-center justify-content-center" style="height: 85vh" v-if="arrAppView.length === 0">
            {{$t('REQUEST_EMPTY')}}
          </div>
    </div>
</template>
<script>
import { authenticationService } from "@/_services";

export default {
  data() {
    return {
      apps: [],
      panel: [0, 1, 2, 3],
      arrAppView: [],
      keySearchApp: null,
    };
  },
  created() {
    this.getApplication();
  },
  watch: {
    keySearchApp(val) {
      this.arrAppView = this.filterData(this.apps, val);
    },
  },
  methods: {
    openApp(app) {
      if (app.url) {
        window.open(app.url ? app.url : '#');
      }
    },
    filterData(arr, key) {
      const array = JSON.parse(JSON.stringify(arr));
      if (key) {
        for (let index = 0; index < array.length; index++) {
          array[index].appLinks = array[index].appLinks.filter(app => app.name.toLowerCase().includes(key.toLowerCase()))
        }
        return array.filter(e => e.appLinks.length > 0);
      }
      return arr
    },
    getApplication() {
       authenticationService
        .getApp()
        .then(res => {
          this.apps = res.data;
          this.arrAppView = res.data;
          // this.filterData(this.apps, 'Cms')
        })
    },
  }
};
</script>